var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9228_31131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5029 33.5031C25.6172 33.5031 33.0058 26.1145 33.0058 17.0002C33.0058 7.88592 25.6172 0.497314 16.5029 0.497314C7.3886 0.497314 0 7.88592 0 17.0002C0 26.1145 7.3886 33.5031 16.5029 33.5031Z",
    fill: "#4671B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1036 16.4532V9.12695L15.9561 10.3839V16.4532H25.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9561 17.6812V23.7388L25.1036 24.8677V17.6812H15.9561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7281 16.4533V10.5527L7.89648 11.4896V16.4533H14.7281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89648 17.6812V22.7438L14.7281 23.5875V17.6812H7.89648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9228_31131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0 0.497314)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoft-icon.45d806052fdf70f94d269db269acaaa0.svg";
export { ForwardRef as ReactComponent };